import React from "react"
import styled from "styled-components"
const Title = ({ text, className, width,color }) => {
  return (
    <Wraper width={width} color={color} >
      <h2 className={className}>{text}</h2>
    </Wraper>
  )
}

export default Title

const Wraper = styled.div`
  text-align: center;
  color: ${props => props.theme.dg};
  position: relative;
  &::after {
    content: "";
    width: ${props => props.width};
    height: 4px;
    background:   ${props => props.color ? props.color : props.theme.dg};
    display: block;
    margin: 12px auto;
  }
`

   